import { gsap } from 'gsap';

gsap.registerEffect({
  name: "counter",
  extendTimeline: true,
  defaults: {
    duration: 0.5,
    ease: "power1",
    increment: 1,
    stagger: 0,
  },
  effect: (targets, config) => {
    let tl = gsap.timeline();

    targets.forEach((target, i) => {
      const rawEnd = target.dataset.end;
      const isDecimal = /,\d{1,2}$/.test(rawEnd) && !/,\d{3}$/.test(rawEnd);
      const usesDot = /\.\d{3}/.test(rawEnd);
      
      let numericEnd;
      if (isDecimal) {
        numericEnd = parseFloat(rawEnd.replace(',', '.'));
      } else {
        numericEnd = parseFloat(rawEnd.replace(/[.,]/g, ''));
      }

      const rawStart = target.innerText;
      let numericStart;
      if (isDecimal) {
        numericStart = parseFloat(rawStart.replace(',', '.')) || 0;
      } else {
        numericStart = parseFloat(rawStart.replace(/[.,]/g, '')) || 0;
      }
      target.innerText = rawStart;

      const decimalPlaces = isDecimal ? (rawEnd.split(',')[1]?.length ?? 2) : 0;

      tl.to(target, {
        duration: config.duration,
        ease: config.ease,
        onUpdate: function() {
          const progress = this.progress();
          const current = numericStart + (numericEnd - numericStart) * progress;
          
          if (isDecimal) {
            // Formato decimale: "63,68"
            target.innerText = current.toFixed(decimalPlaces).replace('.', ',');
          } else if (usesDot) {
            // Formato migliaia con punto: "32.412"
            target.innerText = Math.round(current)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          } else {
            // Formato migliaia con virgola: "1,063"
            target.innerText = Math.round(current)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
        },
        onComplete: function() {
          // Assicura che il valore finale sia esattamente quello del data-end
          target.innerText = rawEnd;
        }
      }, i * config.stagger);
    });

    return tl;
  }
})